import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  LIST_COLABORADOR_INIT,
  CREATE_COLABORADOR_INIT,
  EDIT_COLABORADOR_INIT
} from '../actionTypes';

import { FarmaError } from 'src/integracoes/modelos/erros';
import { atualizarColaborador, criarColaborador, listarColaboradores } from 'src/integracoes/servicos/mongo-atlas/funcoes/colaboradores';
import { IColaborador } from 'src/integracoes/servicos/mongo-atlas/modelos/IColaborador';
import { colaboradorErrorMsg, createColaboradorSuccess, editColaboradorSuccess, listColaboradoresSuccess } from './actions';

interface FetchListaColaboradoresResult {
  isError: boolean;
  colaboradores: IColaborador[] | null;
  msg: string | null;
}

/* ------------------Lista colaboradores---------------- */
export const fetchListarColaboradores = async (id: string): Promise<FetchListaColaboradoresResult> => {
  try {
    const { status, dados, mensagem } = await listarColaboradores(id);

    if (status && Array.isArray(dados)) {
      return {
        isError: false,
        colaboradores: dados,
        msg: null,
      };
    } else {
      return {
        isError: true,
        colaboradores: [],
        msg: mensagem,
      };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseListarColaboradores({ payload }: { payload: { id: string }; type: any }) {
  const { id } = payload;
  try {
    const { isError, msg, colaboradores }: FetchListaColaboradoresResult = yield call(fetchListarColaboradores, id);
    if (!isError) {
      yield put(listColaboradoresSuccess({ colaboradores: colaboradores }));
    } else {
      yield put(colaboradorErrorMsg({ msg: msg }));
    }
  } catch (error: any) {
    yield put(
      colaboradorErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchListarColaboradores() {
  yield takeEvery(LIST_COLABORADOR_INIT, parseListarColaboradores);
}

/* ------------------Criar colaborador ---------------- */
export const fetchCriarColaborador = async (colaborador: any) => {
  try {
    const { status, dados, mensagem } = await criarColaborador(colaborador);
    if (status) {
      return {
        isCreated: true,
        msg: mensagem,
        data: dados
      };
    } else {
      return { isCreated: false, msg: mensagem, data: null };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseCriarColaborador({ payload }: { payload: any, type: any }) {
  const { colaborador } = payload;
  try {
    const { isCreated, msg, data } = yield call(fetchCriarColaborador, colaborador);
    if (isCreated) {
      yield put(createColaboradorSuccess({ msg, isCreated, colaborador: data }));
    } else {
      yield put(colaboradorErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(
      colaboradorErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchCriarColaborador() {
  yield takeEvery(CREATE_COLABORADOR_INIT, parseCriarColaborador);
}

/* ------------------Atualiza colaborador ---------------- */
export const fetchAtualizarColaborador = async (id: string, colaborador: any) => {
  try {
    const { status, dados, mensagem } = await atualizarColaborador(id, colaborador);
    if (status) {
      return {
        isUpdated: true,
        msg: mensagem,
        data: dados
      };
    } else {
      return { isUpdated: false, msg: mensagem, data: null };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseAtualizarColaborador({ payload }: { payload: any; type: any }) {
  const { id, colaborador } = payload;
  try {
    const { isUpdated, msg } = yield call(fetchAtualizarColaborador, id, colaborador);
    if (isUpdated) {
      yield put(editColaboradorSuccess({ msg, isUpdated, colaborador }));
    } else {
      yield put(colaboradorErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(
      colaboradorErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchAtualizarColaborador() {
  yield takeEvery(EDIT_COLABORADOR_INIT, parseAtualizarColaborador);
}

// WATCHS
export default function* rootSaga() {
  yield all([
    fork(watchListarColaboradores),
    fork(watchCriarColaborador),
    fork(watchAtualizarColaborador)
  ]);
}
